// extracted by mini-css-extract-plugin
module.exports = {"image":"SetupCard_image__1gDuj","card":"SetupCard_card__3EJXe","card-active":"SetupCard_card-active__13rlJ","content":"SetupCard_content__SxeWD"};